/* ============================================================================
 * onne-color-cards.js  ·  WS-4 — Cards color-aware en la colección ÔNNE
 * ----------------------------------------------------------------------------
 * Cuando la clienta filtra por una familia de color (faceta Search & Discovery
 * `custom.color_families`) o navega una colección `shop-by-X`, las product cards
 * deben mostrar la foto de ESE color, no la default.
 *
 * Cómo: `snippets/product-card-onne.liquid` emite en el <a> de cada card un
 * atributo `data-color-images='{"wine":"<url>","black":"<url>",…}'` (claves =
 * color crudo en minúsculas; URL = primera media cuyo alt contiene el color, L-018).
 * Este script detecta la familia/color activo y hace swap de la <img> hero.
 *
 * Principios: ADITIVO + fallback graceful. Si algo falla (sin atributo, JSON
 * roto, sin foto del color) la card se queda con su imagen default — nunca rompe
 * el grid. JS aislado, sin dependencias del theme.
 * ========================================================================== */
(function () {
  'use strict';

  // Mapa color_crudo (minúsculas) -> familia(s) (minúsculas). Mismo criterio que
  // el populate de `custom.color_families` (59→13). Combos -> 2 familias.
  var FAMILY_OF = {
    'black': ['black'],
    'white': ['white'],
    'egret': ['white'],
    'paper': ['white'],
    'linen': ['white'],
    'nude': ['nude'],
    'beige': ['nude'],
    'oat apricot': ['nude'],
    'brown': ['brown'],
    'dark brown': ['brown'],
    'chocolate': ['brown'],
    'chocolate brown': ['brown'],
    'birch brown': ['brown'],
    'sand brown': ['brown'],
    'sepia': ['brown'],
    'burnt coffee brown': ['brown'],
    'gray': ['gray'],
    'camel gray': ['gray'],
    'camel grey': ['gray'],
    'ultimate gray': ['gray'],
    'ultimate grey': ['gray'],
    'silver': ['gray'],
    'stone white gray': ['gray'],
    'gray apricot': ['gray'],
    'blue': ['blue'],
    'water blue': ['blue'],
    'navy blue': ['blue'],
    'sunny mountain blue': ['blue'],
    'denim': ['blue'],
    'grey blue': ['blue'],
    'green': ['green'],
    'dark green': ['green'],
    'olive': ['green'],
    'light khaki': ['green'],
    'light fruit green': ['green'],
    'pink': ['pink'],
    'light pink': ['pink'],
    'powder pink': ['pink'],
    'cherry pink': ['pink'],
    'sakura pink': ['pink'],
    'rose pink': ['pink'],
    'peach pink': ['pink'],
    'grapefruit pink': ['pink'],
    'red': ['red'],
    'wine': ['red'],
    'orange': ['orange'],
    'light apricot': ['orange'],
    'yellow': ['yellow'],
    'creamy yellow': ['yellow'],
    'light yellow': ['yellow'],
    'lemon': ['yellow'],
    'purple': ['purple'],
    'lilac': ['purple'],
    'print': ['print'],
    // combos -> ambas familias
    'black white': ['black', 'white'],
    'white black': ['white', 'black'],
    'black nude': ['black', 'nude'],
    'nude black': ['nude', 'black'],
    'nude white': ['nude', 'white'],
    'grey white': ['gray', 'white'],
    'gray green': ['gray', 'green']
  };

  // Conjunto de nombres de familia válidos (minúsculas) para distinguir
  // handles shop-by-<familia> de shop-by-<color-crudo>.
  var FAMILY_SET = {};
  Object.keys(FAMILY_OF).forEach(function (raw) {
    FAMILY_OF[raw].forEach(function (fam) { FAMILY_SET[fam] = true; });
  });

  var SELECTOR_LINK = '.product-card-onne__link[data-color-images]';
  var SELECTOR_HERO = '.product-card-onne__image:not(.product-card-onne__image--hover)';

  /**
   * Objetivo de color activo a partir de la URL (filtro de familia + handle shop-by).
   * @returns {{families: Object, rawExact: string|null, rawContains: string|null}|null}
   *   null = no hay color activo (no tocar las cards).
   */
  function activeTarget() {
    var families = {};
    var rawExact = null;
    var rawContains = null;

    // 1) Filtro de faceta: filter.p.m.custom.color_families=<Familia> (puede repetirse)
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (key.indexOf('color_families') !== -1) {
          var fam = String(value || '').trim().toLowerCase();
          if (fam) families[fam] = true;
        }
      });
    } catch (e) { /* noop */ }

    // 2) Colección shop-by-X (arregla Shop By Color de paso)
    var m = window.location.pathname.match(/\/collections\/shop-by-([^/?#]+)/i);
    if (m && m[1]) {
      var suffix = decodeURIComponent(m[1]).replace(/-/g, ' ').trim().toLowerCase();
      if (FAMILY_OF[suffix]) {
        // suffix es un color crudo (p.ej. "wine") -> preferir su foto exacta
        rawExact = suffix;
        rawContains = suffix;
        FAMILY_OF[suffix].forEach(function (fam) { families[fam] = true; });
      } else if (FAMILY_SET[suffix]) {
        families[suffix] = true;
      } else {
        // handle desconocido: intento best-effort por substring
        rawContains = suffix;
        families[suffix] = true;
      }
    }

    if (Object.keys(families).length === 0 && !rawExact && !rawContains) return null;
    return { families: families, rawExact: rawExact, rawContains: rawContains };
  }

  /**
   * Elige la clave de color (de las disponibles en la card) que mejor casa con
   * el objetivo activo. Orden de prioridad: color crudo exacto > familia explícita
   * > nombre de familia como substring > substring crudo. Null si nada casa.
   */
  function pickKey(images, target) {
    var keys = Object.keys(images);
    if (keys.length === 0) return null;

    // 1) color crudo exacto (shop-by-<color>)
    if (target.rawExact && images[target.rawExact]) return target.rawExact;

    // 2) familia explícita (mapa 59->13)
    var i, k, fams;
    for (i = 0; i < keys.length; i++) {
      k = keys[i];
      fams = FAMILY_OF[k];
      if (fams) {
        for (var j = 0; j < fams.length; j++) {
          if (target.families[fams[j]]) return k;
        }
      }
    }

    // 3) nombre de familia contenido en la clave (robustez ante colores no mapeados)
    var famNames = Object.keys(target.families);
    for (i = 0; i < keys.length; i++) {
      k = keys[i];
      for (var f = 0; f < famNames.length; f++) {
        if (famNames[f].length > 2 && k.indexOf(famNames[f]) !== -1) return k;
      }
    }

    // 4) substring del color crudo del handle
    if (target.rawContains) {
      for (i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(target.rawContains) !== -1) return keys[i];
      }
    }

    return null;
  }

  function swapCard(link, target) {
    var raw = link.getAttribute('data-color-images');
    if (!raw) return;
    var images;
    try { images = JSON.parse(raw); } catch (e) { return; }
    if (!images || typeof images !== 'object') return;

    var key = pickKey(images, target);
    if (!key) return; // sin foto de ese color -> dejar la default (graceful)
    var entry = images[key];
    if (!entry) return;

    // entry = {i: hero, h: hover, v: variantId}. Backward-compat: string = solo hero.
    var imgUrl = (typeof entry === 'string') ? entry : entry.i;
    var hovUrl = (typeof entry === 'string') ? entry : (entry.h || entry.i);
    var vid = (typeof entry === 'object' && entry) ? entry.v : '';
    if (!imgUrl) return;

    var hero = link.querySelector(SELECTOR_HERO);
    if (!hero) return;
    if (hero.getAttribute('data-onne-color-src') === imgUrl) return; // ya aplicado

    // 1) Imagen hero -> foto del color filtrado
    hero.setAttribute('data-onne-color-src', imgUrl);
    hero.setAttribute('data-onne-color-key', key); // debug/QA: color elegido
    hero.srcset = imgUrl; // 1 candidato => el navegador usa este, ignora el srcset original
    hero.src = imgUrl;

    // 2) Imagen hover -> misma familia de color (evita el flash al color por defecto)
    var hov = link.querySelector('.product-card-onne__image--hover');
    if (hov && hovUrl) { hov.srcset = hovUrl; hov.src = hovUrl; }

    // 3) Enlace -> abre la PDP en el color filtrado (?variant=v). Conserva el path
    //    actual (incluido prefijo de idioma) y solo reemplaza la query.
    if (vid) {
      var href = link.getAttribute('href') || '';
      var base = href.split('?')[0];
      if (base) link.setAttribute('href', base + '?variant=' + vid);
    }
  }

  var root = null;
  var observer = null;
  var scheduled = false;

  function applyAll() {
    var target = activeTarget();
    if (!target) return; // nada activo -> no tocar (el grid muestra la default)
    var links = (root || document).querySelectorAll(SELECTOR_LINK);
    for (var i = 0; i < links.length; i++) swapCard(links[i], target);
  }

  function run() {
    if (observer) observer.disconnect();
    try { applyAll(); } catch (e) { /* graceful */ }
    if (observer && root) {
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      run();
    }, 0);
  }

  function init() {
    root = document.querySelector('results-list') || document.querySelector('.product-grid-container');
    if (!root) return; // no es una página de colección -> nada que hacer
    observer = new MutationObserver(schedule);
    run(); // primer pase (deep-link a filtro, shop-by-X, etc.)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
